import { Navigate, createFileRoute } from '@tanstack/react-router';

import { ActivityTab } from '@/features/settings/components/ActivityTab';
import { useWorkspace } from '@/features/workspaces';

export const Route = createFileRoute(
  '/workspaces/$workspaceId/settings/activity',
)({
  component: ActivityRoute,
});

export function ActivityRoute() {
  const { workspaceId } = Route.useParams();
  const { data: workspace } = useWorkspace(workspaceId);
  if (!workspace) return null;
  // The log is its owners' and the org admins' (spec 191). A member who follows
  // an old link opens General rather than an empty panel, as before (spec 194).
  if (workspace.access?.can_manage === false) {
    return (
      <Navigate
        to="/workspaces/$workspaceId/settings/general"
        params={{ workspaceId }}
        replace
      />
    );
  }
  return <ActivityTab workspaceId={workspaceId} />;
}
